<template>
    <div>
        <div v-if="isDataLoading"></div>
        <div v-else>
            <h1 class="main-title">Ajout d'un cours</h1>
            <h3 class="subtitle">{{ actualSection.title }}</h3>
            <section v-show="actualSection.name === 'typeChoice'" class="danceTypes">
                <div v-for="category in course_categories"
                     :key="category.id"
                     class="card uni-display-3"
                     @click="showCourseSection(category.name)"
                >
                    {{ category.name }}
                </div>
            </section>
            <section v-for="category in course_categories"
                     :key="category.id"
                     v-show="actualSection.name === category.name"
                     class="course-container"
            >
                <rich-course-card v-for="course in category.courses"
                                  :courses-user-already-takes="user.courses"
                                  :course="course"
                                  :category="category"
                                  :key="course.id">
                    <template slot="subscription">
                        <uni-button @click.native="addCourse(course)"
                                    class="button--small button--secondary">
                            Choisir ce cours
                        </uni-button>
                    </template>
                </rich-course-card>
            </section>
            <section v-show="actualSection.name === 'submit'">
                <div class="course-container">
                    <rich-course-card v-for="course in selectedCourses"
                                      :course="course"
                                      :category="course_categories.find(el => el.id === course.course_category_id)"
                                      :key="course.id">
                    </rich-course-card>
                </div>
                <uni-loading-button :is-disable="loading" :text="'Inscrire ' + user.firstname"
                                    @click.native="submitCourse">
                    Inscrire {{ user.firstname }}
                </uni-loading-button>
            </section>
        </div>
    </div>
</template>

<script>
    import RichHeaderSecondaryLevel from "../../components/c-blocks/RichHeaderSecondaryLevel";
    import UniButton from "../../components/a-elements/UniButton";
    import RichCourseCard from "../../components/a-elements/RichCourseCard";
    import UniLoadingButton from "../../components/b-patterns/UniLoadingButton";
    import {mapGetters} from "vuex";

    export default {
        name: "adminAddCourse",
        components: {UniLoadingButton, RichCourseCard, UniButton, RichHeaderSecondaryLevel},
        data() {
            return {
                actualSection: {
                    name: 'typeChoice',
                    title: 'Choix du type de danse',
                },
                course_categories: [],
                selectedCourse: null,
                user: {},
                isDataLoading: true,
                loading: false,
                selectedCourses: []
            }
        },
        computed: {
            ...mapGetters({isSubscriptionOpen: 'isSubscriptionOpen'})
        },
        methods: {
            showCourseSection(category) {
                this.actualSection.name = category
            },
            addCourse(course) {
                this.selectedCourses.push(course)
                this.actualSection.name = 'submit'
                this.actualSection.title = "Envoi de la demande d'inscription"
            },
            submitCourse() {
                this.loading = true
                this.selectedCourses.forEach((course) => {
                    let course_id
                    if (this.selectedCourses.length > 1) {
                        course_id = 'more'
                    } else {
                        course_id = course.id
                    }
                    this.$addCourseToUser(this.$route.params.id, course.id)
                        .then(data => {
                            this.$router.push({name: 'admin.users.edit', params: {id: this.user.id}})
                        })
                })
            },
        },
        created() {
            this.$getModel('course_categories')
                .then(data => {
                    this.course_categories = data
                    let $this = this
                })
            this.$getModel('users', this.$route.params.id)
                .then(data => {
                    this.user = data
                    this.isDataLoading = false
                })


        }
    }
</script>

<style scoped lang="scss">
    .danceTypes {
        display: grid;
        grid-template-columns: 1fr 1fr;
        gap: 16px;

        > .card {
            text-align: center;
            height: 92px;
            transition: var(--transition-quick);
            cursor: pointer;
            line-height: 64px;

            &:hover {
                background: var(--color-primary);
                color: white;
            }
        }
    }

    .course-container {
        display: grid;
        grid-template-columns: 1fr;
        gap: 16px;

        > .card {
            > /deep/ button {
                width: 100%;
            }
        }
    }

    .subtitle {
        margin-bottom: 16px;
    }

    @include screen-xs {
        .danceTypes {
            gap: 16px;
        }
    }

    @include screen-s {
        .danceTypes {
            grid-template-columns: 1fr 1fr 1fr;
        }
    }

    @include screen-m {
        .course-container {
            grid-template-columns: 1fr 1fr;
            gap: 24px;
        }
    }
</style>
